// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entities-list-container {
  padding: 0 24px;
}
@media (max-width: 1024px) {
  .entities-list-container {
    margin-top: 135px;
  }
}

@media (max-width: 1024px) {
  h6 {
    margin-bottom: 0px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/afericoes/afericao-ampliacao/afericao-ampliacao.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACI;EAHJ;IAIY,iBAAA;EAEV;AACF;;AACM;EADN;IAEY,kBAAA;IACA,kBAAA;EAGV;AACF","sourcesContent":[".entities-list-container{\n    padding: 0 24px;\n\n    @media(max-width:1024px){\n            margin-top: 135px;\n    }\n}\nh6{\n      @media(max-width:1024px){\n            margin-bottom: 0px;\n            text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
